import { toast } from 'react-toastify';
import appApi from '../../../../../../api/app-api';
import globalSettingsStores from '../../../../../../stores/settings-stores';

export interface CreateCalendarVacationPayload {
  title: string;
  description: string;
  startDate: Date | null;
  endDate: Date | null;
}

export const createCalendarVacationOperation = async (
  payload: CreateCalendarVacationPayload,
  setLoading: (isLoading: boolean) => void,
  onClose: () => void,
) => {
  try {
    const title = payload.title?.trim();
    if (!title) {
      toast.warn('יש להזין כותרת');
      return;
    }
    if (title.length > 50) {
      toast.warn('כותרת חייבת להיות עד 50 תווים');
      return;
    }
    if ((payload.description ?? '').length > 255) {
      toast.warn('תיאור חייב להיות עד 255 תווים');
      return;
    }

    setLoading(true);
    await appApi.createCalendarVacation({
      title,
      description: payload.description ?? '',
      startDate: payload.startDate,
      endDate: payload.endDate,
    });
    await globalSettingsStores.fetchSetting();
    toast.success('החופשה נוספה בהצלחה');
    onClose();
  } catch (e) {
    toast.error('הוספת החופשה נכשלה, נסה שוב בעוד מספר רגעים');
    console.error(`createCalendarVacationOperation failed: ${e}`);
  } finally {
    setLoading(false);
  }
};
